import { get } from "lodash";

export const isLoading = state => get(state, "marina.loading");
export const getMarina = state => get(state, "marina", {});
export const getMarinaName = state => get(state, "marina.data.MarinaName", "");
export const getMarinaDetails = state => get(state, "marina.data", {});
export const getMarinaIsLoading = state => get(state, "marina.loading");
export const getMarinaIsLoaded = state => get(state, "marina.loaded");
export const getAllMarinas = state => get(state, "marina.list", []);
